function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Insulation"
}, /*#__PURE__*/React.createElement("title", null, "190902_VF_Product_NL_Icons"), /*#__PURE__*/React.createElement("path", {
  d: "M255.6 255.1V119.7l14.7 7.7 13.2-25-141.8-74.1L0 102.4l13.2 25 14.7-7.7v135.4h227.7zm-28.4-28.2H56.4v-122l85.3-44.6 85.3 44.6.2 122z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.7 212.4H70.5v-97.5l71.1-37 71.1 37v97.5zM85 197.9h113.2v-74.1l-56.6-29.4L85 123.7v74.2z"
}))));